import Model from './Model'
import Team from './Team'

export default class DispatchDocket extends Model
{
    get published_status () {
        return this.published_at ? ('Published ' + this.published_at) : 'Not Published'
    }

    getFormAttributes() {
        const attributes = this.only(['title', 'reference', 'requires_acknowledgement', 'renews_at', 'section', 'document'])
        attributes['team_ids'] = Team.make(this.teams).map(x => x.toDropdown())
        return attributes
    }

    static parseAttributes(attributes = {}) {
        return this.parseDropdownAttributes(attributes, ['team_ids'])
    }

    static async all (filter = 'pending', canManage = false) {
        const config = { params: { filter, managing: canManage } }
        const { data } = await Http.get(route('api.v1.documents'), config)
        return this.make(data)
    }

    static async create (attributes) {
        const url = route('api.v1.documents.store')
        const { data } = await Http.post(url, this.parseAttributes(attributes))
        return this.make(data)
    }

    async update (attributes = {}) {
        const url = route('api.v1.documents.update', this.id)
        const payload = this.constructor.parseAttributes({ ...this.getFormAttributes(), ...attributes })
        const { data } = await Http.put(url, payload)
        return this.fill(data)
    }

    async delete () {
        await Http.delete(route('api.v1.documents.delete', this.id))
    }

    async publish () {
        const url = route('api.v1.documents.publish', this.id)
        const { data } = await Http.put(url)
        this.fill(data)
        
        return this
    }

    async unpublish () {
        const url = route('api.v1.documents.unpublish', this.id)
        const { data } = await Http.put(url)
        this.fill(data)
        
        return this
    }

    async acknowledge () {
        const url = route('api.v1.documents.acknowledge', this.id)
        const { data } = await Http.put(url)
        this.fill(data)
        
        return this
    }
}
